// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { Creditor } from './creditor';
import { CreditorClaimType } from './creditor-claim-type';
import { Lookup } from './lookup';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CreditorClaim extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  creditorClaimId!: number;
  accountId!: number;
  admittedAmount!: number;
  admittedTaxAmount!: number;
  advisedAmount!: number;
  claimedNettAmount!: number;
  claimedTaxAmount!: number;
  claimedTotalAmount!: number;
  createdBy!: string;
  createdDate!: Date;
  creditorClaimTypeId!: number;
  creditorId!: number;
  data1?: number;
  data2?: number;
  data3?: number;
  data4?: number;
  data5?: number;
  distributedAmount!: number;
  geersamount!: number;
  lookupId?: number;
  ni!: number;
  rank!: number;
  rataamount!: number;
  reference1?: string;
  reference2?: string;
  rejectedAmount!: number;
  rejectedPriorityAdmitted!: number;
  rejectedPriorityAmount!: number;
  spare1?: number;
  spare2?: number;
  ts!: string;
  underConsiderationAmount!: number;
  updatedBy!: string;
  updatedDate!: Date;
  account!: Account;
  creditor!: Creditor;
  creditorClaimType!: CreditorClaimType;
  lookup!: Lookup;
}

